import * as API from '@/api';
import Vue from 'vue'
import DEFINES from '@/defines';
import { isDateTimePast } from "@/helpers";
import ChatRoomService from "@/services/ChatRoomService";
import * as firebase from "firebase";
// ==================== STATE =====================

const state = {
  chatRoomUnreadMessagesCount: 0,
  chatroomID:null,
  userUniqueChatRoomId:null,
  currentOnlineUserCount:0,
  currentOfflineUserCount:0,
  onlineUsersList: [],
  offlineUsersList: [],
  chatsList: [],
  selectedSender:null,
  selectedRecepient:[],
  privateMessages:[],
  senderRejectedProfiles:[]
};
  
// ==================== ACTIONS =====================
  
const actions = {
  // Set Current Chatrrom ID
  setChatRoom({commit}, payload){
    commit('SET_CHATRROM_ID', payload)
  },
  /** Select Member for Chatting */
  selectRecepientMember({ commit }, payload) {
    commit('SET_SELECTED_RECEPIENT_USER', payload)
  },
  /** Set Tab Type */
  selectMemberTab({ commit }, payload) {
    commit('SET_MEMBER_TAB', payload)
  },
  /** Select Member for Chatting */
  unSelectChattingMember({ commit }) {
    commit('UNSET_SELECTED_RECEPIENT_USER')
  },
  /**
   * Register Memebrs into the chatroom
   */
  async registerMember (context, payload) {
    var response = await API.chatRoom.registerMember(payload);
    return response;
  },
  /**
   * Update Memeber profile into the chatroom
   */
  async updateMember (context, payload) {
    var response = await API.chatRoom.updateMember(payload);
    return response;
  },
  /**
   * Auto Register Memebrs into the chatroom
   */
  async autoRegisterMember (context, payload) {
    var response = await API.chatRoom.autoRegisterMember(payload);
    return response;
  },
  /**
   * 
   * Check for the Member Existence
   * i.e, if the Current Online User is already registered to the chatroom or not 
   */
  async checkMemberExistence (context, payload) {
    var response = await API.chatRoom.checkMemberExistence(payload);
    return response;
  },

  /**
   * 
   * Set Current Member Profile
   * 
   */
  async setCurretMemberProfile ({ commit, state }, payload) {
    let memberDetail = await ChatRoomService.__getMemberDetailBasedOnId(state.chatroomID, payload.id)
    if (memberDetail) {
      commit('SET_SELECTED_SENDER_USER', memberDetail)
    }
    
    
  },

  /**
   * Get Chatroom Paticipants List
   */
  async bindUsersWithFirebase({ commit, state, rootState }) { 
    await ChatRoomService.listenToAddedMembers(state.chatroomID, (newUser) => {
      // console.log(newUser);
      
      if (newUser.consumer_id!=rootState.consumer.profile.id) {
        commit('ADD_USER_TO_PARTICIPANT_LIST', newUser)
        commit('SET_ONLINE_USERS_COUNT', state.onlineUsersList.length)
      }

    });

  },

  // Get Rejected Profiles
  async bindRejectedUsersWithFirebase({commit, state, rootState}) {
    await ChatRoomService.listenToRejectedProfiles(state.chatroomID, rootState.consumer.profile.id , (rejectedProfiles) => {
      commit('REMOVE_REJECTED_PROFILES_FROM_ONLINE_USERS', Object.keys(rejectedProfiles).map(Number))
    })
  },
  // Get Chat Users Lists ( Friends )
  async bindChatListWithFirebase({ commit, state, rootState  }) {
    await ChatRoomService.listenAllChatsForMember(state.chatroomID, state.selectedSender.id, (chatList) => {
      let chatUserList = Object.values(chatList)
      if (chatUserList.length > 0 ) {
        chatUserList.forEach(async (element) => {
            const chatId = [rootState.consumer.profile.id, element.consumer_id].sort().join('_');
            let privateChatRef = await ChatRoomService.__privateChatsReference(state.chatroomID, chatId).once('value')
            let privateChatRefSnapshot = privateChatRef.val();
            
            commit('SET_CHAT_LIST', {
              ...element,
              latest_message:privateChatRefSnapshot.lastMessage
            })
        })
      } 
    })
  },
  /**
   * Create or Obtain the Unique Chatrrom ID between two persons
   */
  async setPrivateChatAndMessages({ commit, state, rootState }) {

    // Get The Unique chat id between the Two Users
    let chatID =  await ChatRoomService.__createPrivateChat(state.chatroomID, rootState.consumer.profile.id, state.selectedRecepient.consumer_id)
    commit('SET_USER_UNIQUE_CHAT_ROOM_ID',chatID)
    // Set The Messages For the Chat
    // let chatMessages = await ChatRoomService.__getPrivateMessages(state.chatroomID, chatID)
    // if (chatMessages) {
    //   let messages = Object.entries(chatMessages).map(([messageDocID, messageData]) => ({
    //     id: messageDocID,
    //     ...messageData
    //   }));
      
    // }
    
  },
  /**
   * Send Private Message To User in a Chat
   */
  async sendMessageInChat({commit, state, rootState },message){
    // If Message is First message in chat then set message approve status to false
    if (state.privateMessages.length == 0) {
      await ChatRoomService.__addPrivateMessage(state.chatroomID, state.userUniqueChatRoomId, rootState.consumer.profile.id, state.selectedRecepient.consumer_id, message,'text',null, 'not_approved')
    }else{
      await ChatRoomService.__addPrivateMessage(state.chatroomID, state.userUniqueChatRoomId, rootState.consumer.profile.id, state.selectedRecepient.consumer_id, message)

    }
    
  },

  /**
   * Send Reaction to a Message in a a particular chat 
   */
  async sendMessageReaction({commit, state}, {message_id, message_reaction}) {
    let reaction =  await ChatRoomService.__addReactionToMessage(state.chatroomID, message_id, message_reaction)
  },

  async listenToPrivateMessages({ commit, state, rootState }){
    const chatRoomId = state.chatroomID;
    const chatId = state.userUniqueChatRoomId;
    const currentUserId = rootState.consumer.profile.id;  // Current user's ID

    if (!chatRoomId || !chatId) {
      console.error("Chat room ID or chat ID is not set.");
      return;
    }

    await ChatRoomService.listenToAddedMessages(chatRoomId, chatId, async (newMessage) => {
      let Message = {
        ...newMessage,
        reactions:[]
      }
      // console.log(Message);
      
      commit('ADD_MESSAGE_PRIVATE_CHAT', Message) // Add new messages to the reactive array

    });

    await ChatRoomService.listenToEditedMessages(chatRoomId, chatId, (updatedMessage) => {
      // commit('EDIT_MESSAGE_PRIVATE_CHAT', updatedMessage);
      // Optional: Filter out the sender's own message if needed
      if (updatedMessage.senderId !== currentUserId) {
        console.log("Message edited:", updatedMessage);
      }
    });

    await ChatRoomService.listenToDeletedMessages(chatRoomId, chatId, (deletedMessage) => {
      // commit('DELETE_MESSAGE_PRIVATE_CHAT', deletedMessage);
      // Optional: Filter out the sender's own deleted message if needed
      if (deletedMessage.senderId !== currentUserId) {
        console.log("Message deleted:", deletedMessage);
      }
    });
  },

  async stopListeningToPrivateMessages({ state }) {
    const chatRoomId = state.chatroomID;
    const chatId = state.userUniqueChatRoomId;
  
    if (!chatRoomId || !chatId) {
      console.error("Chat room ID or chat ID is not set.");
      return;
    }
  
    // Unsubscribe from the listeners
    await ChatRoomService.stopListeningToPrivateMessages(chatRoomId, chatId);
    await ChatRoomService.stopListeningToAddedMessages(chatRoomId, chatId);
    await ChatRoomService.stopListeningToEditedMessages(chatRoomId, chatId);
    await ChatRoomService.stopListeningToDeletedMessages(chatRoomId, chatId);
  },

  /** Update The Current user status as 
   * Online/Offline
   */

  async updateMemberStatus({commit, state}, activityStatus) {
    let reaction =  await ChatRoomService.__updateMemberStatus(state.chatroomID, state.selectedSender.id, activityStatus);
  },

  /** Listen to member Status */
  // async listenToMemberStatus({commit,state, rootState}) {
  //   await ChatRoomService.listenToMemberProfileChange(state.chatroomID,(snapshot) => {
  //     commit('UPDATE_USER_CHATROOM_PROFILE',{consumer_id:rootState.consumer.profile.id, payload:snapshot})
  //   });
  // },

  /** Handle First Message Accept/Reject */
  async handleMemberRequest({commit, state},type) {
    let response =  await ChatRoomService.__approveRejectFirstMessage(
      state.chatroomID,
      state.selectedSender.consumer_id, 
      state.selectedRecepient.consumer_id,
      type
    )
    if (type == 'approve') {
      commit('APPROVE_CHAT_FIRST_MESSAGE')
    }
    // Update Chat first message 
    return true
  },

  async stopListeningToAddedMembers({ state }) {
    const chatRoomId = state.chatroomID;
    // Unsubscribe from the listeners
    await ChatRoomService.stopListeningToAddedMembers(chatRoomId);
  },

  async stopListeningToRejectedMembers({ state, rootState }) {
    const chatRoomId = state.chatroomID;
    // Unsubscribe from the listeners
    await ChatRoomService.stoplisteningToRejectedProfiles(chatRoomId, rootState.consumer.profile.id);
  },

  async stoplisteningAllChatsForMember({ state, rootState }) {
    const chatRoomId = state.chatroomID;
    // Unsubscribe from the listeners
    await ChatRoomService.stoplisteningAllChatsForMember(chatRoomId, rootState.consumer.profile.id);
  },
  
  async listenToMemberProfile({ state, commit, rootState }) {
    await ChatRoomService.listenToMemberProfile(state.chatroomID,state.selectedSender.id, (snapshot) => {
      let rejectedProfiles= []
      if ('rejectedProfiles' in snapshot) {
        rejectedProfiles = Object.entries(snapshot.rejectedProfiles).map(([rejectedProfileDocID, profileData]) => ({
          rejectedProfileDocID,
          ...profileData
        }));
      }
      if ('acceptedProfiles' in snapshot) {
        let chatUserList = Object.values(snapshot.acceptedProfiles)
        if (chatUserList.length > 0 ) {
          chatUserList.forEach(async (element) => {
              const chatId = [rootState.consumer.profile.id, element.consumer_id].sort().join('_');
              let privateChatRef = await ChatRoomService.__privateChatsReference(state.chatroomID, chatId).once('value')
              let privateChatRefSnapshot = privateChatRef.val();
              
              let chatUnReadMessageCount = await ChatRoomService.__countUnreadMessagesPrivateChat(state.chatroomID,chatId, element.consumer_id,rootState.consumer.profile.id)
              
              commit('SET_CHAT_LIST', {
                ...element,
                unreadMessaegCount:chatUnReadMessageCount,
                latest_message:privateChatRefSnapshot.lastMessage
              })
          })
        } 
      }
      commit('SET_SENDER_REJECTED_PROFILES', rejectedProfiles)
    });
  },
  async stoplisteningToMemberProfile({ state, rootState }) {
    await ChatRoomService.stoplisteningAllChatsForMember(state.chatroomID, state.selectedSender.id);
  },

  async markChatAsRead({state}) {
    await ChatRoomService.setChatMessagesAsRead(state.chatroomID, state.userUniqueChatRoomId);
  },

  async listenToMessageReactions({ state, commit }, messageId) {
    await ChatRoomService.listenToMessageReactions(state.chatroomID, messageId, ({message_id, reaction}) => {
      commit('SET_MESSAGE_REACTIONS', {message_id, reaction});
    });
  },

  async listenToMemberStatus({ state, commit }, memberId) {
    if (memberId) {
      await ChatRoomService.listenToMemberStatus(state.chatroomID, memberId, (snapshot) => {
        commit('UPDATE_USER_CHATROOM_PROFILE',{member_id:memberId, payload:snapshot})
        
      });
      
    }
  },
  async stoplisteningToMemberProfile({ state, rootState }, memberId) {  
    await ChatRoomService.stoplisteningToMemberProfile(state.chatroomID, memberId);
  }

};
  
// ==================== GETTERS =====================
  
const getters = {
  chatroomID: state=> state.chatroomID,
  chatRoomUnreadMessagesCount: state => state.chatRoomUnreadMessagesCount,
  onlineUsersList : state => state.onlineUsersList,
  offlineUsersList : state => state.offlineUsersList,
  onlineUsersCount : state => state.currentOnlineUserCount,
  offlineUsersCount : state => state.currentOfflineUserCount,
  chatList: state => state.chatsList,
  senderUser: state => state.selectedSender,
  recepientUser: state => state.selectedRecepient,
  privateMessages: state => state.privateMessages,
  senderRejectedProfiles: state => state.senderRejectedProfiles
};
  
// ==================== MUTATIONS =====================
  
const mutations = {
  ADD_USER_TO_PARTICIPANT_LIST(state, usersList) {
    // Check if The Current user is Already in the List or Not
    if (state.onlineUsersList.length > 0) {
      let foundUser = state.onlineUsersList.find(item => item.id === usersList.id)
      // Add Only when if user is not in the list
      if (!foundUser) {
        state.onlineUsersList.push(usersList)
      }

    }else{
      state.onlineUsersList.push(usersList)

    }
  },
  SET_SENDER_REJECTED_PROFILES(state, rejectedProfileList) {
    state.senderRejectedProfiles = rejectedProfileList
  },
  SET_OFFLINE_USERS_LIST(state, usersList) {
    state.offlineUsersList = usersList
  },
  SET_ONLINE_USERS_COUNT(state,currentCount) {
    state.currentOnlineUserCount = currentCount
  },
  SET_OFFLINE_USERS_COUNT(state, count) {
    state.currentOfflineUserCount = count
  },
  SET_CHAT_LIST(state, chats) {
    let foundMember = state.chatsList.find((element) => element.id === chats.id)
    if (state.chatsList.length == 0) {
      state.chatsList.push(chats) 
    }else if (!foundMember) {
      state.chatsList.push(chats) 
    }
  },
  SET_SELECTED_SENDER_USER(state, userDetail) {
    state.selectedSender = userDetail;
  },
  SET_SELECTED_RECEPIENT_USER(state, userDetail) {
    state.selectedRecepient = userDetail
  },
  UNSET_SELECTED_RECEPIENT_USER(state) {
    state.selectedRecepient = null
    state.privateMessages = []
    state.userUniqueChatRoomId = null

  },
  SET_CHATRROM_ID(state, room_id) {
    state.chatroomID = room_id
  },
  SET_USER_UNIQUE_CHAT_ROOM_ID(state, id) {
    state.userUniqueChatRoomId = id
  },
  SET_PRIVATE_MESSAGES(state, payload) {
    state.privateMessages = payload
  },
  APPROVE_CHAT_FIRST_MESSAGE(state) { 
    state.privateMessages[0].approved = true;
  },
  ADD_MESSAGE_PRIVATE_CHAT(state, message) {
    // First Check if The Message with same time stamp exists in the Array on not
    let found = state.privateMessages.find(element => element.timestamp === message.timestamp)
    if (!found) {
      state.privateMessages.push(message)
    }
  },
  UPDATE_USER_CHATROOM_PROFILE(state, {member_id, payload}) {
    console.log("Update user Profile");
    
    // Step 1 Find the Index of the Member in the Online Users List
    let memberParticipantIndex = state.onlineUsersList.findIndex(member => member.id == member_id);
    
    if (memberParticipantIndex !== -1) {
      Vue.set(state.onlineUsersList, memberParticipantIndex, payload)
    }

    // Step 2 Find the Index of the Member in the Chats List
    let memberChatsIndex = state.chatsList.findIndex(member => member.id == member_id);
    let memberChatObject = state.chatsList[memberChatsIndex]

    if (memberChatsIndex !== -1) {
      Vue.set(state.chatsList, memberChatsIndex, {...memberChatObject,onlineStatus:payload.onlineStatus})
    }
    
    // Step 3 Check if the Selected Recipient is the smeber_id User
    
    if (state.selectedRecepient && (state.selectedRecepient.id == member_id)) {
      // console.log(state.selectedRecepient.id, member_id);
      state.selectedRecepient = {...state.selectedRecepient, onlineStatus:payload.onlineStatus}
    }
    
  },
  REMOVE_REJECTED_PROFILES_FROM_ONLINE_USERS(state, profile_ids) {
    let newOnlineUsersList = state.onlineUsersList.filter((element) => !profile_ids.includes(element.consumer_id))
    state.onlineUsersList = newOnlineUsersList
    state.currentOnlineUserCount = newOnlineUsersList.length
  },
  SET_MESSAGE_REACTIONS(state, {message_id, reaction}) {
    const messageIndex = state.privateMessages.findIndex(message => message.id == message_id);
    
    if (messageIndex !== -1) {
      state.privateMessages[messageIndex].reactions.push(reaction);
    }
  }
};
  
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};